import React from "react";
import Tooltip from "../../../ui/Tooltip";
import IconInfo from "../../icon/IconInfo";

type Props = {
  id: string;
  label?: string;
  tooltip?: React.ReactNode;
};

export default function ConfigurationFormField({
  id,
  label,
  tooltip,
  ...props
}: React.PropsWithChildren<Props>) {
  const labelId = `label${id}`;

  return (
    <div className="grid grid-cols-6 gap-3 p-2 mb-3">
      <div className="col-span-2">
        <label className="block mt-3">
          <span className="font-bold">{label}</span>
          {tooltip && (
            <Tooltip content={tooltip} label={labelId} className="pl-0.5">
              <IconInfo className="text-gray-dark" />
            </Tooltip>
          )}
        </label>
      </div>
      <div className="col-span-4 mt-1 flex ">{props.children}</div>
    </div>
  );
}
